import moment from "moment";

export const mapStartTimeToIndex = {
  "00:00": 0,
  "01:00": 2,
  "02:00": 4,
  "03:00": 6,
  "04:00": 8,
  "05:00": 10,
  "06:00": 12,
  "07:00": 14,
  "08:00": 16,
  "09:00": 18,
  "10:00": 20,
  "11:00": 22,
  "12:00": 24,
  "13:00": 26,
  "14:00": 28,
  "15:00": 30,
  "16:00": 32,
  "17:00": 34,
  "18:00": 36,
  "19:00": 38,
  "20:00": 40,
  "21:00": 42,
  "22:00": 44,
  "23:00": 46,
};

// Basic turf mapping for booking (physical turf numbers)
export const mapTurf = {
  turfA: "1",
  turfB: "2",
  turfC: "3",
  turfD: "4",
  turfE: "5",
};

// Location and sport-specific turf consolidation mapping for pricing tiers
// This maps pricing tier turfs to their physical turf numbers based on location
export const locationSportTurfConsolidation = {
  srinagar: {
    "cricket-net": {
      // Net A (3 Players Max) and Net A (6 Players Max) both use physical turf 1
      turfA: "1", // Net A (3 Players Max)
      turfC: "3", // Net A (6 Players Max) - consolidated to turf 1
      // Net B (3 Players Max) and Net B (6 Players Max) both use physical turf 2
      turfB: "2", // Net B (3 Players Max)
      turfD: "4", // Net B (6 Players Max) - consolidated to turf 2
    },
    // Add other sports for srinagar location
    // "tennis": {
    //   "turfA": "1", // Court A (Singles)
    //   "turfB": "1", // Court A (Doubles) - same physical court
    //   "turfC": "2", // Court B (Singles)
    //   "turfD": "2", // Court B (Doubles) - same physical court
    // },
  },
  // baramulla: {
  //   "cricket-net": {
  //     // Baramulla might have different consolidation setup
  //     turfA: "1", // Net A (3 Players Max)
  //     turfC: "1", // Net A (6 Players Max) - consolidated to turf 1
  //     turfB: "2", // Net B (3 Players Max)
  //     turfD: "2", // Net B (6 Players Max) - consolidated to turf 2
  //   },
  //   // Add other sports for baramulla location
  // },
  // Add other locations as needed
  // "anantnag": {
  //   "cricket-net": {
  //     // Different consolidation for anantnag
  //   },
  // },
};

// Legacy support - keep the old structure for backward compatibility
export const sportTurfConsolidation = {
  "cricket-net": {
    // Net A (3 Players Max) and Net A (6 Players Max) both use physical turf 1
    turfA: "1", // Net A (3 Players Max)
    turfC: "1", // Net A (6 Players Max) - consolidated to turf 1
    // Net B (3 Players Max) and Net B (6 Players Max) both use physical turf 2
    turfB: "2", // Net B (3 Players Max)
    turfD: "2", // Net B (6 Players Max) - consolidated to turf 2
  },
  // Add other sports with pricing tiers as needed
  // "tennis": {
  //   "turfA": "1", // Court A (Singles)
  //   "turfB": "1", // Court A (Doubles) - same physical court
  //   "turfC": "2", // Court B (Singles)
  //   "turfD": "2", // Court B (Doubles) - same physical court
  // },
};

// Helper function to get the consolidated turf number for booking
export const getConsolidatedTurfNumber = (sport, turfKey, location = null) => {
  const sportKey = sport.toLowerCase().replace(/\s+/g, "-");

  // First try location-specific consolidation if location is provided
  if (location) {
    const locationKey = location.toLowerCase();
    const locationConsolidationMap =
      locationSportTurfConsolidation[locationKey];

    if (locationConsolidationMap && locationConsolidationMap[sportKey]) {
      const consolidationMap = locationConsolidationMap[sportKey];
      if (consolidationMap && consolidationMap[turfKey]) {
        return consolidationMap[turfKey];
      }
    }
  }

  // Fallback to sport-specific consolidation (legacy support)
  const consolidationMap = sportTurfConsolidation[sportKey];
  if (consolidationMap && consolidationMap[turfKey]) {
    return consolidationMap[turfKey];
  }

  console.log(turfKey, mapTurf[turfKey]);
  // Final fallback to basic mapping if no consolidation is defined
  return mapTurf[turfKey] || turfKey;
};

export const isSlotAvailable = (list, startTime, duration) => {
  if (startTime === "" || list.length === 0) {
    return false;
  }

  const startIndex = mapStartTimeToIndex[startTime];
  const lastIndex = startIndex + duration * 2 - 1;
  for (let i = startIndex; i <= lastIndex; i++) {
    if (list[i] === false) {
      return false;
    }
  }
  return true;
};

export const checkSlotAvailabilityForDuration = (list, startTime, duration) => {
  if (startTime === "" || list.length === 0) {
    return { available: false, reason: "No slots available" };
  }

  const startIndex = mapStartTimeToIndex[startTime];
  const lastIndex = startIndex + duration * 2 - 1;

  // Check if the requested duration exceeds available slots
  if (lastIndex >= list.length) {
    return {
      available: false,
      reason: "Requested duration exceeds available time slots",
    };
  }

  // Check each slot in the requested duration
  for (let i = startIndex; i <= lastIndex; i++) {
    if (list[i] === false) {
      // Calculate which hour is unavailable
      const unavailableHour = Math.floor((i - startIndex) / 2) + 1;
      const unavailableTime = addTimeHours(startTime, unavailableHour);
      return {
        available: false,
        reason: `Slot at ${unavailableTime} is already booked`,
      };
    }
  }

  return { available: true, reason: "" };
};

export const addTimeHours = (time, hours) =>
  `${moment(time, ["h:m a", "H:m"]).add(hours, "hour").format("HH:mm")}`;

export const parseSlotInterval = ({ startTime, endTime, cost }) => {
  let res = [];
  const intervals =
    (mapStartTimeToIndex[endTime] - mapStartTimeToIndex[startTime]) / 2;

  for (let i = 0; i < intervals; i++) {
    res = [...res, { time: addTimeHours(startTime, i), cost }];
  }

  return res;
};

export const parseSlots = (list) => {
  const len = list.length;
  let res = [];

  for (let i = 0; i < len; i++) {
    res = [...res, ...parseSlotInterval(list.at(i))];
  }

  return res;
};

const parseAvailibityArray = (list, slots) => {
  const len = slots.length;
  let res = [];

  for (let i = 0; i < len; i++) {
    const start = mapStartTimeToIndex[slots.at(i).startTime];
    const end = mapStartTimeToIndex[slots.at(i).endTime];
    for (let j = start; j < end; j++) {
      res = [...res, j];
    }
  }

  return list.map((flag, index) => (res.includes(index) ? flag : false));
};

export const parseBookNowApiData = (
  slotsResponse,
  pricingResponse,
  selectedDate = null,
  dayMappings = null,
  specialSchedule = null,
  holidayBookingStatus = null
) => {
  // Helper function to determine if a date is a holiday based on day mappings
  const isHolidayDay = (date, mappings) => {
    if (!date || !mappings) return false;

    // Convert to Date object if it's a string or dayjs object
    const dateObj =
      typeof date === "string" ? new Date(date) : date.$d ? date.$d : date;

    // Get day name in lowercase
    const dayName = dateObj
      .toLocaleDateString("en-US", { weekday: "long" })
      .toLowerCase();

    // Check if this day is marked as a holiday in the mappings
    return mappings[dayName] === true;
  };

  // Helper function to determine if a date is in special schedule
  const isSpecialScheduleDay = (date, specialScheduleData) => {
    if (!date || !specialScheduleData) return false;

    // Check if the special schedule data indicates the date is present
    return specialScheduleData.is_present === true;
  };

  // Determine if it's a holiday based on day mappings, special schedule, or holiday table
  const isHolidayByDayMapping = isHolidayDay(selectedDate, dayMappings);
  const isHolidayBySpecialSchedule = isSpecialScheduleDay(
    selectedDate,
    specialSchedule
  );
  const isHolidayByHolidayTable = holidayBookingStatus?.is_holiday === true;

  // Use HOLIDAY pricing if any holiday condition is true
  const isHoliday =
    isHolidayByDayMapping ||
    isHolidayBySpecialSchedule ||
    isHolidayByHolidayTable;

  // Handle the new backend response structure
  if (
    slotsResponse.available_slots &&
    Array.isArray(slotsResponse.available_slots)
  ) {
    // New backend structure
    const availableSlots = slotsResponse.available_slots;

    // Map turf numbers to availability arrays
    const turfAvailability = {};
    availableSlots.forEach((slot) => {
      const turfKey = `turf${slot.turf_number}`;
      turfAvailability[turfKey] = slot.available_slots;
    });

    // Generate slots with pricing from the pricing API
    const generateSlotsWithPricing = (turfNumber, pricingData) => {
      try {
        const slots = [];

        // Use HOLIDAY rates when applicable; fall back to NORMAL if HOLIDAY missing
        // (football/box-cricket often have no HOLIDAY pricing rows configured)
        const preferredType = isHoliday ? "HOLIDAY" : "NORMAL";
        let turfPricing =
          pricingData?.[preferredType]?.[turfNumber.toString()] || [];
        if (turfPricing.length === 0 && isHoliday) {
          turfPricing =
            pricingData?.NORMAL?.[turfNumber.toString()] || [];
        }

        // If no pricing data is available, return empty slots
        if (
          !pricingData ||
          Object.keys(pricingData).length === 0 ||
          turfPricing.length === 0
        ) {
          // Return empty slots instead of hardcoded pricing
          // This prevents showing incorrect pricing when no config exists
          console.warn(
            `No pricing configuration found for turf ${turfNumber} (tried ${preferredType}${isHoliday ? " then NORMAL" : ""}). Returning empty slots.`
          );
          return [];
        }

        // Only generate slots that are configured in the pricing API
        turfPricing.forEach((priceSlot) => {
          const startTime = priceSlot.startTime;
          const endTime = priceSlot.endTime;
          const cost = priceSlot.cost;

          // Generate hourly slots within the configured time range
          let currentTime = startTime;

          while (currentTime < endTime) {
            // Convert time to next hour
            const [hours, minutes] = currentTime.split(":").map(Number);
            const nextHour = hours + 1;
            const nextTime = `${nextHour.toString().padStart(2, "0")}:${minutes
              .toString()
              .padStart(2, "0")}`;

            // Add the slot if it's within the configured range
            if (nextTime <= endTime) {
              slots.push({
                startTime: currentTime,
                endTime: nextTime,
                cost: cost,
              });
            }

            currentTime = nextTime;
          }
        });

        return slots;
      } catch (error) {
        console.error(`Error generating slots for turf ${turfNumber}:`, error);
        return [];
      }
    };

    const result = {
      date: selectedDate ? selectedDate.toString() : "",
      bookingAllowed: true, // Default to true, will be determined by slot availability
      slotsAvailability: {
        turfA: turfAvailability.turf1 || Array(48).fill(true),
        turfB: turfAvailability.turf2 || Array(48).fill(true),
        turfC: turfAvailability.turf3 || Array(48).fill(true),
        turfD: turfAvailability.turf4 || Array(48).fill(true),
        turfE: turfAvailability.turf5 || Array(48).fill(true),
      },
      slots: {
        turfA: (() => {
          try {
            const rawSlots = generateSlotsWithPricing(1, pricingResponse);
            const parsedSlots = parseSlots(rawSlots) || [];
            return parsedSlots;
          } catch (error) {
            console.error("Error processing turfA:", error);
            return [];
          }
        })(),
        turfB: (() => {
          try {
            const rawSlots = generateSlotsWithPricing(2, pricingResponse);
            const parsedSlots = parseSlots(rawSlots) || [];
            return parsedSlots;
          } catch (error) {
            console.error("Error processing turfB:", error);
            return [];
          }
        })(),
        turfC: (() => {
          try {
            const rawSlots = generateSlotsWithPricing(3, pricingResponse);
            const parsedSlots = parseSlots(rawSlots) || [];
            return parsedSlots;
          } catch (error) {
            console.error("Error processing turfC:", error);
            return [];
          }
        })(),
        turfD: (() => {
          try {
            const rawSlots = generateSlotsWithPricing(4, pricingResponse);
            const parsedSlots = parseSlots(rawSlots) || [];
            return parsedSlots;
          } catch (error) {
            console.error("Error processing turfD:", error);
            return [];
          }
        })(),
        turfE: (() => {
          try {
            const rawSlots = generateSlotsWithPricing(5, pricingResponse);
            const parsedSlots = parseSlots(rawSlots) || [];
            return parsedSlots;
          } catch (error) {
            console.error("Error processing turfE:", error);
            return [];
          }
        })(),
      },
    };

    // Determine bookingAllowed based on slot availability
    const hasAvailableSlots = Object.values(result.slots).some(
      (turfSlots) => Array.isArray(turfSlots) && turfSlots.length > 0
    );
    result.bookingAllowed = hasAvailableSlots;

    return result;
  } else if (
    slotsResponse &&
    slotsResponse.slotsAvailability &&
    slotsResponse.routine
  ) {
    // Legacy structure (fallback)
    const {
      date,
      bookingAllowed,
      slotsAvailability: {
        turfA: availibilityTurfA,
        turfB: availibilityTurfB,
        turfC: availibilityTurfC,
        turfD: availibilityTurfD,
        turfE: availibilityTurfE,
      },
      routine: { turfA, turfB, turfC, turfD, turfE },
    } = slotsResponse;

    return {
      date,
      bookingAllowed,
      slotsAvailability: {
        turfA: parseAvailibityArray(availibilityTurfA, turfA) || [],
        turfB: parseAvailibityArray(availibilityTurfB, turfB) || [],
        turfC: turfC ? parseAvailibityArray(availibilityTurfC, turfC) : [],
        turfD: turfD ? parseAvailibityArray(availibilityTurfD, turfD) : [],
        turfE: turfE ? parseAvailibityArray(availibilityTurfE, turfE) : [],
      },
      slots: {
        turfA: parseSlots(turfA) || [],
        turfB: parseSlots(turfB) || [],
        turfC: turfC ? parseSlots(turfC) : [],
        turfD: turfD ? parseSlots(turfD) : [],
        turfE: turfE ? parseSlots(turfE) : [],
      },
    };
  } else if (
    // Handle case where only pricing data is available (no slots data)
    (!slotsResponse || Object.keys(slotsResponse).length === 0) &&
    pricingResponse &&
    Object.keys(pricingResponse).length > 0
  ) {
    // Generate slots with pricing from the pricing API
    const generateSlotsWithPricing = (turfNumber, pricingData) => {
      const slots = [];

      // Use HOLIDAY rates when applicable; fall back to NORMAL if HOLIDAY missing
      const preferredType = isHoliday ? "HOLIDAY" : "NORMAL";
      let turfPricing =
        pricingData?.[preferredType]?.[turfNumber.toString()] || [];
      if (turfPricing.length === 0 && isHoliday) {
        turfPricing = pricingData?.NORMAL?.[turfNumber.toString()] || [];
      }

      // Only generate slots that are configured in the pricing API
      turfPricing.forEach((priceSlot) => {
        const startTime = priceSlot.startTime;
        const endTime = priceSlot.endTime;
        const cost = priceSlot.cost;

        // Generate hourly slots within the configured time range
        let currentTime = startTime;

        while (currentTime < endTime) {
          // Convert time to next hour
          const [hours, minutes] = currentTime.split(":").map(Number);
          const nextHour = hours + 1;
          const nextTime = `${nextHour.toString().padStart(2, "0")}:${minutes
            .toString()
            .padStart(2, "0")}`;

          // Add the slot if it's within the configured range
          if (nextTime <= endTime) {
            slots.push({
              startTime: currentTime,
              endTime: nextTime,
              cost: cost,
            });
          }

          currentTime = nextTime;
        }
      });

      return slots;
    };

    // Check if any pricing data is available
    const hasAnyPricing =
      pricingResponse &&
      Object.keys(pricingResponse).length > 0 &&
      (pricingResponse.NORMAL || pricingResponse.HOLIDAY);

    if (!hasAnyPricing) {
      console.warn("No pricing configuration found. Booking will be disabled.");
    }

    const result = {
      date: selectedDate
        ? selectedDate.toString()
        : new Date().toISOString().split("T")[0], // Use selected date or current date as fallback
      bookingAllowed: hasAnyPricing, // Only allow booking if pricing is configured
      slotsAvailability: {
        turfA: Array(48).fill(true), // Assume all slots are available
        turfB: Array(48).fill(true),
        turfC: Array(48).fill(true),
        turfD: Array(48).fill(true),
        turfE: Array(48).fill(true),
      },
      slots: {
        turfA: (() => {
          const rawSlots = generateSlotsWithPricing(1, pricingResponse);
          const parsedSlots = parseSlots(rawSlots) || [];
          return parsedSlots;
        })(),
        turfB: (() => {
          const rawSlots = generateSlotsWithPricing(2, pricingResponse);
          const parsedSlots = parseSlots(rawSlots) || [];
          return parsedSlots;
        })(),
        turfC: (() => {
          const rawSlots = generateSlotsWithPricing(3, pricingResponse);
          const parsedSlots = parseSlots(rawSlots) || [];
          return parsedSlots;
        })(),
        turfD: (() => {
          const rawSlots = generateSlotsWithPricing(4, pricingResponse);
          const parsedSlots = parseSlots(rawSlots) || [];
          return parsedSlots;
        })(),
        turfE: (() => {
          const rawSlots = generateSlotsWithPricing(5, pricingResponse);
          const parsedSlots = parseSlots(rawSlots) || [];
          return parsedSlots;
        })(),
      },
    };

    return result;
  } else {
    // Defensive fallback: return empty slots structure for malformed responses
    console.error(
      "=== Using defensive fallback - no valid data structure found ==="
    );
    console.error("slotsResponse:", slotsResponse);
    console.error("pricingResponse:", pricingResponse);
    return {
      date: "",
      bookingAllowed: false,
      slotsAvailability: {
        turfA: [],
        turfB: [],
        turfC: [],
        turfD: [],
        turfE: [],
      },
      slots: {
        turfA: [],
        turfB: [],
        turfC: [],
        turfD: [],
        turfE: [],
      },
    };
  }
};

export const getTotalCost = (list, startTime, duration) => {
  if (
    !list ||
    !Array.isArray(list) ||
    list.length === 0 ||
    !startTime ||
    !duration
  ) {
    return 0;
  }

  const index = list.findIndex(({ time }) => time === startTime);
  if (index === -1) {
    return 0;
  }

  let sum = 0;
  for (let i = index; i < index + duration && i < list.length; i++) {
    const slot = list.at(i);
    if (slot && typeof slot.cost === "number") {
      sum = sum + slot.cost;
    }
  }
  return sum;
};

export const parseNewBookingApiData = (response) => {
  // Handle different response structures
  if (response && response.response) {
    // Response wrapped in { response: { ... } }
    const data = response.response;

    return {
      order_id: data.order_id || data.orderId || "",
      transactionId: data.transaction_id || data.transactionId || "",
      currency: data.payment_details?.currency || data.currency || "INR",
      amount: data.amount || data.total_amount || 0,
      booking_id: data.booking_id || data.bookingId || "",
    };
  } else if (response && typeof response === "object") {
    // Direct response object

    return {
      order_id: response.order_id || response.orderId || "",
      transactionId: response.transaction_id || response.transactionId || "",
      currency:
        response.payment_details?.currency || response.currency || "INR",
      amount: response.amount || response.total_amount || 0,
      booking_id: response.booking_id || response.bookingId || "",
    };
  } else {
    return {
      order_id: "",
      transactionId: "",
      currency: "INR",
      amount: 0,
      booking_id: "",
    };
  }
};
